import React, { useContext, useState } from 'react';
import Table from '@amzn/meridian/table/table.js';
import Row from '@amzn/meridian/row/row.js';
import Column from '@amzn/meridian/column/column.js';
import { useDeviceLayout } from '../../commons/context/DeviceLayoutContext.js';
import TableRow from '@amzn/meridian/table/table-row.js';
import TableCell from '@amzn/meridian/table/table-cell.js';
import { FormattedMessage, injectIntl } from 'react-intl';
import Text from '@amzn/meridian/text/text.js';
import Input from '@amzn/meridian/input/input.js';
import Pagination from '@amzn/meridian/pagination/pagination.js';
import Link from '@amzn/meridian/link/link.js';
import { DEFAULT_MESSAGE_FOR_DWELL_PAGE_ALERT, DWELL_DETAILED_VIEW_PACKAGE_LIST_SIZE, FEATURES } from '../../commons/constants/CommonConstants.js';
import { chainWalk, handleBlankValue } from '../../commons/CommonUtils.js';
import { dwellDetailedUiFilterOption, emptyStringToHyphen, fetchAssociate, getDwellPackageStatus, getDwellPackageStatusColor, getDwellPackageSubStatusForFilter, getFormattedMessageForState, getPackageStatus } from '../../util/CommonUtils.js';
import Tag from '@amzn/meridian/tag/tag.js';
import CorePackage from '../../assets/images/CorePackageIcon/CorePackage.png';
import GroceryPackage from '../../assets/images/GroceryPackageIcon/GroceryIcon.png';
import PackageTypeHeader from '../../assets/images/PackageTypeIcon/PackageTypeHeader.png';
import { FeatureConfigContext } from '../../commons/context/FeatureConfigContext.js';
import { DwellFilterContext } from '../../commons/context/DwellFilterContext.js';
import Select from '@amzn/meridian/select/select.js';
import SelectOption from '@amzn/meridian/select/select-option.js';
import Alert from '@amzn/meridian/alert/alert.js';

// This is used to show the package list in detailed dwell view along with table level filters.

const DwellDetailedViewTable = (props) => {

    const formattedIdPrefix = "packagelist.";
    const {viewModelFilter} = useContext(DwellFilterContext);
    
    //Filter values
    const [dwellTimeFilter, setDwellTimeFilter] = useState("")
    const [trackingIdFilter, setTrackingIdFilter] = useState("")
    const [packageSubStatusFilter, setPackageSubStatusFilter] = useState([])
    const [lastScanByFilter, setLastScanByFilter] = useState("")
    const [lastScanLocationFilter, setLastScanLocationFilter] = useState("")
    const [packageTypeFilter] = useState("")
    const {configViewModel} = useContext(FeatureConfigContext);
    
    // View Options
    const [currentPage, setCurrentPage] = useState(1);
    const searchPath = "#/detailPage/";
    
    const {spacingInset_shorthand2} = useDeviceLayout();
    
    /** Sorting **/
    const [sortColumn, setSortColumn] = useState("minutesInState")
    const [sortDirection, setSortDirection] = useState("descending")
    
    const onSort = ({sortColumn, sortDirection}) => {
        setSortDirection(sortDirection)
        setSortColumn(sortColumn)
        transformedViewList.sort((a,b) => {
            if (a[sortColumn] < b[sortColumn]) {
                return sortDirection === "ascending" ? -1 : 1
            }
            if (a[sortColumn] > b[sortColumn]) {
                return sortDirection === "ascending" ? 1 : -1
            }
            return 0
        })
    };
    /** Filters **/
    const inLineFilter = (packageData, filter, key) => {
        return filter.length === 0 || (packageData[key] && packageData[key].toString().toLowerCase().startsWith(filter.toLowerCase()));
    }

    const inLineFilterNumericValue = (packageData, filter, key) => {
        return filter.length === 0 || (!isNaN(Number(filter)) && !isNaN(packageData[key]) && packageData[key] === Number(filter));
    }

    const inLineFilterForPackageSubStatus = (packageData, filterList) => {
        if ( !filterList || (filterList.length !== undefined && filterList.length === 0)) {
            return true;
        }
        let result = false;
        filterList.forEach(filterValue => {
            if (getDwellPackageSubStatusForFilter(packageData.state, packageData.packageType, filterValue)) {
                result = true;
            }
        })
        return result;
    }
    
    let packageFilteredList = props.data;
    let numberColumnList = ['minutesInState'];
    let dateTimeColumnList = [];
    let transformList = (packageList) => {
        let tranformedList = [];
        packageList.forEach((packageItem) => {
            let transformedPackageItem = {};
            Object.entries(packageItem).forEach(([key, value]) => {
                if (numberColumnList.includes(key)) {
                    transformedPackageItem[key] = Number(value);
                }
                else if(dateTimeColumnList.includes(key)) {
                    transformedPackageItem[key] = new Date(value);
                }
                else {
                    transformedPackageItem[key] = value;
                }
            });
            tranformedList.push(transformedPackageItem);
        });
        return tranformedList
    }
    let transformedViewList = transformList(packageFilteredList);

    let packageSubStatusColumnSet = new Set();
    transformedViewList.map((packageDetail) => {
        if (packageDetail.state) {
            packageSubStatusColumnSet.add(getFormattedMessageForState(packageDetail.state, packageDetail.packageType));
        }
        return packageDetail
    })
    const packageSubStatusValuesList = [...packageSubStatusColumnSet];

    transformedViewList.sort((a,b) => {
        if (a[sortColumn] < b[sortColumn]) {
            return sortDirection === "ascending" ? -1 : 1
        }
        if (a[sortColumn] > b[sortColumn]) {
            return sortDirection === "ascending" ? 1 : -1
        }
        return 0
    })

    const getPackageShareableLink = (trackingId)  => {
        const shareablePath = "detailPage/";
        const redirectPath = new URL(props.baseURL);
        redirectPath.searchParams.set("shareableLink", shareablePath.concat(trackingId));
        return redirectPath;
    };

    transformedViewList = transformedViewList
    .filter(packageData => dwellDetailedUiFilterOption(viewModelFilter, packageData, "packageType", "isGrocery"))
    .filter(packageData => dwellDetailedUiFilterOption(viewModelFilter, packageData, "packageScheduledDeliveryWindow", "state"))
    .filter(packageData => inLineFilterNumericValue(packageData, dwellTimeFilter, "minutesInState"))
    .filter(packageData => inLineFilter(packageData, trackingIdFilter, "trackingId"))
    .filter(packageData => inLineFilterForPackageSubStatus(packageData, packageSubStatusFilter))
    .filter(packageData => inLineFilter(packageData, lastScanByFilter, "lastScanBy"))
    .filter(packageData => inLineFilter(packageData, lastScanLocationFilter, "lastScanLocation"))
    .filter(packageData => inLineFilter(packageData, packageTypeFilter, "packageSubType"));


    
    // This flag control to show the column PackageType
    const showPackageTypeColumnEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_PACKAGE_TYPE_COLUMN_DWELL_ENABLED], false);

    return (
        <React.Fragment>
        {(packageFilteredList && packageFilteredList.length === DWELL_DETAILED_VIEW_PACKAGE_LIST_SIZE) ?
                    (
                    <Row>
                        <Alert>{props.intl.formatMessage({
                                    id: "dwell.detail.view.alert.message",
                                    defaultMessage: DEFAULT_MESSAGE_FOR_DWELL_PAGE_ALERT
                                })}
                        </Alert>
                    </Row>
                    )
                    : null }
        <Column spacing="small" spacingInset={spacingInset_shorthand2}>
            
                <Row widths={["grid-12"]}>
                <div style={{"overflowX": "scroll"}}>
                    <Table
                    showStripes={true}  headerColumns={1} stickyHeaderColumn={true}
                                   fixHeaderRows={true} headerRows={1} stickyHeaderRow={true}
                                   showDividers={true} spacing="small"
                    sortColumn={sortColumn} sortDirection={sortDirection} onSort={onSort}>
                            <TableRow>    

                                <TableCell sortColumn="minutesInState" width={200} alignmentHorizontal="left">
                                    <Text type="h100"><FormattedMessage id ={formattedIdPrefix.concat("Dwell Time".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Dwell Time"/></Text></TableCell>
                                <TableCell sortColumn="trackingId" width={150} alignmentHorizontal="left">
                                    <Text type="h100"><FormattedMessage id ={formattedIdPrefix.concat("Tracking Id".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Tracking Id"/></Text></TableCell>
                                <TableCell sortColumn="status" width={200} alignmentHorizontal="left" ><Text type="h100">
                                    <FormattedMessage id ={formattedIdPrefix.concat("Status".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Status"/></Text></TableCell>
                                <TableCell sortColumn="subStatus" width={200} alignmentHorizontal="left" ><Text type="h100">
                                    <FormattedMessage id ={formattedIdPrefix.concat("Sub-status".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Sub-status"/></Text></TableCell>
                                <TableCell sortColumn="lastUpdatedTime" width={200} alignmentHorizontal="left">
                                    <Text type="h100"><FormattedMessage id ={formattedIdPrefix.concat("Last Updated Time".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Last Scan"/></Text></TableCell>
                                <TableCell sortColumn="lastScanBy" width={150} alignmentHorizontal="left"><Text type="h100">
                                    <FormattedMessage id ={formattedIdPrefix.concat("Last Scan By".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Associate"/></Text></TableCell>
                                <TableCell sortColumn="lastScanLocation" width={150} alignmentHorizontal="left"><Text type="h100">
                                    <FormattedMessage id ={formattedIdPrefix.concat("Last Scan Location".toLocaleLowerCase().split(' ').join('_'))} defaultMessage="Location"/></Text></TableCell>
                                {showPackageTypeColumnEnabled ? 
                                <TableCell sortColumn="packageType" width={150} alignmentHorizontal="left">
                                    <img src={PackageTypeHeader} alt="Package Type" height="27" width="30" />
                                </TableCell>
                                : null}
                            </TableRow>
                            {
                            // Adding the column filters on the table
                            }
                            <TableRow>
                                <TableCell>
                                    <Input type="text" size="small"
                                        value={dwellTimeFilter}
                                        onChange={setDwellTimeFilter}/>
                                </TableCell>

                                <TableCell>
                                    <Input type="text" size="small"
                                        value={trackingIdFilter}
                                        onChange={setTrackingIdFilter}/>
                                </TableCell>

                                <TableCell>
                                    
                                </TableCell>

                                <TableCell>
                                    <Select
                                    onChange={(data) => {
                                        setPackageSubStatusFilter(data);
                                    }}
                                    value={packageSubStatusFilter}
                                    placeholder={props.intl.formatMessage({
                                        id: "dwell.table.filter.package.substate",
                                        defaultMessage: "Sub Status"
                                    })}>
                                        {[...packageSubStatusValuesList].sort().map(packageSubState => (
                                            <SelectOption key={packageSubState} label={packageSubState} value={packageSubState} />
                                        ))}
                                    </Select>

                                </TableCell>

                                <TableCell>
                                    
                                </TableCell>

                                <TableCell>
                                    <Input type="text" size="small"
                                        value={lastScanByFilter}
                                        onChange={setLastScanByFilter}/>
                                </TableCell>

                                <TableCell>
                                    <Input type="text" size="small"
                                        value={lastScanLocationFilter}
                                        onChange={setLastScanLocationFilter}/>
                                </TableCell>
                                {showPackageTypeColumnEnabled ? 
                                <TableCell>
                                    
                                </TableCell>
                                : null}

                            </TableRow>

                            {transformedViewList.slice((currentPage-1) * 30 , currentPage * 30).map(result => {
                                return (
                                <TableRow>
                                    <TableCell alignmentHorizontal="center"><Text type="b300">{emptyStringToHyphen(result.minutesInState)}</Text></TableCell>
                                    
                                    <TableCell alignmentHorizontal="left">
                                        <Link target = "_blank" rel="noreferrer noopener" href = {getPackageShareableLink(result.trackingId)}>
                                    {result.trackingId}
                                        </Link>
                                    </TableCell>
                                    <TableCell alignmentHorizontal="left">
                                        <Tag type={getDwellPackageStatusColor(getDwellPackageStatus(result.state), result.packageType)}>{getPackageStatus(result.state, result.packageType)}</Tag>
                                    </TableCell>
                                    <TableCell alignmentHorizontal="left">
                                        {getFormattedMessageForState(result.state, result.packageType)}
                                    </TableCell>
                                    <TableCell alignmentHorizontal="left"><Text type="b300">{emptyStringToHyphen(result.lastUpdatedTime)} </Text></TableCell>
                                    <TableCell alignmentHorizontal="left"><Text type="b300">{fetchAssociate(searchPath, handleBlankValue(result.lastScanBy), result.lastUpdatedTime)}</Text></TableCell>
                                    <TableCell alignmentHorizontal="left"><Text type="b300">{emptyStringToHyphen(result.lastScanLocation)}</Text></TableCell>
                                    
                                    {showPackageTypeColumnEnabled ? 
                                        <TableCell alignmentHorizontal="left">
                                            {result.isGrocery ?
                                                <img src={GroceryPackage} alt="Grocery Package" height="20" width="20" /> 
                                                :
                                                <img src={CorePackage} alt="Core Package" height="20" width="20" />
                                            }
                                        </TableCell>
                                    : null}

                                </TableRow> )
                                })
                            }
                            
                        </Table>  
                        </div>
                </Row>
                <div>
                {
                    transformedViewList.length > 0 ?
                        <Row widths={["grid-7"]} spacingInset="large" alignmentHorizontal="center">
                            <Pagination numberOfPages={Math.ceil(transformedViewList.length/ 30)} onChange={setCurrentPage} currentPage={currentPage}/>
                        </Row> : null
                }
                </div>  
            </Column>
            </React.Fragment>
    );
}

export default injectIntl(DwellDetailedViewTable);


// WEBPACK FOOTER //
// ./src/components/dwellRush/DwellDetailedViewTable.js